import type { IconName, StackedIcon } from '@/fontawesome';
import type { Route } from '@/objects/Route';
import type { RouteParams } from '@/objects/RouteParams';
import type { RouteLocationNormalizedGeneric } from 'vue-router';

/**
 * This is the class representing the pinned view.
 * This is the data we need to know to present the shortcut, and be able to navigate back to this view
 */
export class PinnedViewParams {
    public name: string; // The display name of the view should be a translation key

    public routeName: string;
    public routeParams?: RouteParams;
    public fullRoute?: string;
    public hash?: string;

    // The icon for the view
    public icon?: IconName | StackedIcon;

    // The color of the view, if not set will be automatically generated
    public color?: string;

    // If the view is active or not
    public active: boolean = true;

    public constructor(pinnedViewParams?: PinnedViewParams) {
        this.name = pinnedViewParams?.name ?? '';
        this.routeName = pinnedViewParams?.routeName ?? '';
        this.routeParams = pinnedViewParams?.routeParams;
        this.fullRoute = pinnedViewParams?.fullRoute;
        this.hash = pinnedViewParams?.hash;
        this.icon = pinnedViewParams?.icon;
        this.color = pinnedViewParams?.color;
        this.active = pinnedViewParams?.active ?? true;
    }

    public CreateFromRoute(name: string, route: Route) {
        this.name = name;
        this.fullRoute = route.href;
        this.routeName = route.name;
        this.routeParams = route.params;
        this.hash = route.hash;
        return this;
    }

    public getUniqueID(): string {
        return this.routeName + JSON.stringify(this.routeParams) + this.hash;
    }
}
